import { useRef, useState, type ChangeEvent } from 'react'
import { optimizeClientLogo } from '../clientLogo'
import { Icon } from './Icon'

interface Props {
  clientName: string
  value?: string
  onChange: (logo: string | undefined) => void
  onProcessingChange?: (processing: boolean) => void
}

export function ClientLogoField({ clientName, value, onChange, onProcessingChange }: Props) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [error, setError] = useState('')
  const [processing, setProcessing] = useState(false)
  const initials = clientName.trim().slice(0, 2).toUpperCase() || 'CL'

  async function selectLogo(event: ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0]
    event.target.value = ''
    if (!file) return
    setError('')
    setProcessing(true)
    onProcessingChange?.(true)
    try {
      onChange(await optimizeClientLogo(file))
    } catch (uploadError) {
      setError(uploadError instanceof Error ? uploadError.message : 'Não foi possível processar essa imagem.')
    } finally {
      setProcessing(false)
      onProcessingChange?.(false)
    }
  }

  return <div className="client-logo-field">
    <span className="client-logo-field-label">LOGO DO CLIENTE <small>OPCIONAL</small></span>
    <div className="client-logo-upload">
      <span className="client-logo-preview">{value ? <img src={value} alt={`Logo de ${clientName || 'cliente'}`}/> : initials}</span>
      <div className="client-logo-upload-copy">
        <b>{value ? 'Logo selecionada' : 'Adicione a identidade do cliente'}</b>
        <small>PNG, JPG ou WebP · até 5 MB</small>
        <div>
          <button type="button" className="secondary compact-action" disabled={processing} onClick={() => inputRef.current?.click()}><Icon name="upload"/>{processing ? 'Processando…' : value ? 'Trocar imagem' : 'Selecionar imagem'}</button>
          {value && <button type="button" className="client-logo-remove" disabled={processing} onClick={() => { onChange(undefined); setError('') }}>Remover</button>}
        </div>
      </div>
      <input ref={inputRef} className="client-logo-input" type="file" accept="image/png,image/jpeg,image/webp" onChange={selectLogo}/>
    </div>
    {error && <p className="form-error client-logo-error" role="alert">{error}</p>}
  </div>
}
